import { AppConfig } from '@config'

const getQuery = () => new URLSearchParams(window.location.search)

export const tvModeActive = () => getQuery().get('tvmode') === 'true'

export const previewActive = () => getQuery().get('preview') === 'true'

export const getReplayId = () => parseInt(getQuery().get('replay') || '')

export const replayModeActive = () => getReplayId() > 0

export const ovalModeActive = () => getQuery().get('ovalmode') === 'true'

export const kioskModeActive = () => getQuery().get('kiosk') === 'true'

export const get3dModelName = () => getQuery().get('model') || AppConfig['3d'].main()

export function getOvalModeOffsets () {
  const q = getQuery()
  return {
    LDtop: `${q.get('LDtop') || 0}px`,
    LDleft: `${q.get('LDleft') || 0}px`,
    RDtop: `${q.get('RDtop') || 0}px`,
    RDleft: `${q.get('RDleft') || 0}px`
  }
}
